<template>
  <div :class="componentClasses">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  vertical: {
    type: Boolean,
    default: false,
  },
  noWrap: {
    type: Boolean,
  },
  gap: {
    type: String,
    default: "3",
  },
  size: {
    type: String,
  },
  justify: {
    type: String,
  },
});

const componentClasses = computed(() => [
  'stk-buttons',
  props.vertical ? 'is-vertical' : '',
  props.noWrap ? 'has-no-wrap' : '',
  props.gap ? `stk-regap-${props.gap}` : '',
  props.justify && `tw-justify-${props.justify}`,
  props.size ? `stk-size-${props.size}` : '',
]);
</script>


<style>
.stk-buttons {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: start;

  &.has-no-wrap {
    flex-wrap: nowrap;
  }

  &.is-vertical {
    align-self: stretch;
    align-items: stretch;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
